import { $, icons } from './helpers';
import { api } from './api';
import { navigate, isAdmin } from './app';

let activeIdx = -1;

function renderDefaultResults(container: HTMLElement) {
  container.textContent = '';
  const group = document.createElement('div');
  group.className = 'cmd-palette-group';
  const title = document.createElement('div');
  title.className = 'cmd-palette-group-title';
  title.textContent = 'Sayfalar';
  group.appendChild(title);

  const pages = [
    { href: '/dashboard', icon: 'layout-dashboard', label: 'Panel' },
    ...(isAdmin() ? [{ href: '/clients', icon: 'users', label: 'Müşteriler' }] : []),
    { href: '/projects', icon: 'folder-kanban', label: 'Projeler' },
    { href: '/invoices', icon: 'file-text', label: 'Faturalar' },
    { href: '/payments', icon: 'wallet', label: 'Tahsilatlar' },
    { href: '/tickets', icon: 'life-buoy', label: 'Destek Talepleri' },
    ...(isAdmin() ? [{ href: '/finance', icon: 'landmark', label: 'Finans' }] : []),
    { href: '/settings', icon: 'settings', label: 'Ayarlar' },
  ];
  pages.forEach(p => {
    const div = document.createElement('div');
    div.className = 'cmd-result';
    div.setAttribute('data-href', p.href);
    const i = document.createElement('i');
    i.setAttribute('data-lucide', p.icon);
    div.appendChild(i);
    div.appendChild(document.createTextNode(' ' + p.label));
    group.appendChild(div);
  });
  container.appendChild(group);
  icons();
}

export function openCommandPalette() {
  const el = $('#cmd-palette') as HTMLElement;
  el.style.display = 'flex';
  const input = document.getElementById('cmd-palette-input') as HTMLInputElement;
  input.value = '';
  input.focus();
  renderDefaultResults(document.getElementById('cmd-palette-results')!);
  activeIdx = -1;
}

export function closeCommandPalette() {
  ($('#cmd-palette') as HTMLElement).style.display = 'none';
}

function selectResult(el: Element) {
  const href = el.getAttribute('data-href');
  if (href) { closeCommandPalette(); navigate(href); }
}

function updateActive(results: Element[]) {
  results.forEach((r, i) => r.classList.toggle('active', i === activeIdx));
  if (activeIdx >= 0 && results[activeIdx]) results[activeIdx].scrollIntoView({ block: 'nearest' });
}

function renderSearchResults(container: HTMLElement, data: any) {
  container.textContent = '';
  let hasResults = false;
  const sections = [
    { key: 'clients', title: 'Müşteriler', icon: 'user', prefix: '/clients/' },
    { key: 'projects', title: 'Projeler', icon: 'folder-kanban', prefix: '/projects/' },
    { key: 'invoices', title: 'Faturalar', icon: 'file-text', prefix: '/invoices/' },
  ];
  sections.forEach(sec => {
    const items = data[sec.key];
    if (!items?.length) return;
    hasResults = true;
    const group = document.createElement('div');
    group.className = 'cmd-palette-group';
    const t = document.createElement('div');
    t.className = 'cmd-palette-group-title';
    t.textContent = sec.title;
    group.appendChild(t);
    items.forEach((item: any) => {
      const div = document.createElement('div');
      div.className = 'cmd-result';
      div.setAttribute('data-href', sec.prefix + item.id);
      const i = document.createElement('i');
      i.setAttribute('data-lucide', sec.icon);
      div.appendChild(i);
      div.appendChild(document.createTextNode(' ' + (item.name || item.title || item.invoice_number || '')));
      if (item.email || item.client_name) {
        const sub = document.createElement('span');
        sub.style.cssText = 'color:var(--text-muted);font-size:0.85em;margin-left:0.5em';
        sub.textContent = item.email || item.client_name;
        div.appendChild(sub);
      }
      group.appendChild(div);
    });
    container.appendChild(group);
  });
  if (!hasResults) {
    const msg = document.createElement('div');
    msg.style.cssText = 'padding:1rem;color:var(--text-muted);text-align:center';
    msg.textContent = 'Sonuç bulunamadı';
    container.appendChild(msg);
  }
  icons();
  activeIdx = -1;
}

let searchTimer: any;
document.getElementById('cmd-palette-input')?.addEventListener('input', (e) => {
  clearTimeout(searchTimer);
  const q = (e.target as HTMLInputElement).value.trim();
  if (q.length < 2) { renderDefaultResults(document.getElementById('cmd-palette-results')!); return; }
  searchTimer = setTimeout(async () => {
    try {
      const data = await api.get('/search?q=' + encodeURIComponent(q));
      renderSearchResults(document.getElementById('cmd-palette-results')!, data);
    } catch { /* yoksay */ }
  }, 200);
});

document.getElementById('cmd-palette-input')?.addEventListener('keydown', (e) => {
  const results = Array.from(document.querySelectorAll('#cmd-palette-results .cmd-result'));
  if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(activeIdx + 1, results.length - 1); updateActive(results); }
  else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(activeIdx - 1, 0); updateActive(results); }
  else if (e.key === 'Enter' && activeIdx >= 0) { e.preventDefault(); selectResult(results[activeIdx]); }
  else if (e.key === 'Escape') { closeCommandPalette(); }
});

document.getElementById('cmd-palette-results')?.addEventListener('click', (e) => {
  const target = (e.target as Element).closest('.cmd-result');
  if (target) selectResult(target);
});

$('#cmd-palette .cmd-palette-backdrop')?.addEventListener('click', closeCommandPalette);
